import { render, staticRenderFns } from "./TabPecas.vue?vue&type=template&id=0f422f59&scoped=true&"
import script from "./TabPecas.vue?vue&type=script&lang=js&"
export * from "./TabPecas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f422f59",
  null
  
)

export default component.exports